export const SET_LEADS = 'Set_Leads';
export const SET_AUDIO="SET_AUDIO";
export const SETPLAY_SOUND="SETPLAY_SOUND";